import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { userActions } from '@src/store/reducers/userReducer';

import _ from 'lodash';

import { IDomain } from '@src/interfaces/domain.interfaces';

@Component({
    selector: 'domain-directory-service-sync',
    template: require('./domain-directory-service-sync.component.html'),
    styles: [require('./domain-directory-service-sync.component.scss')]
})
export class DomainDirectoryServiceSyncComponent implements OnInit, OnDestroy {
    @Input() public domain: IDomain;

    public roles: any[];
    public projectGroups: any[];

    private unSubscribe: any;

    constructor(
        private store: Store,
        @Inject('$scope') private $scope: any) {
        this.$scope.$watch(() => this.domain, (newValue: any, oldValue: any) => {
            const state = this.store.getState();
            const stateNotExist = state || !state.user || state.user.roles || state.user.projectGroups;
            if (newValue === oldValue || !stateNotExist) {
                return;
            }
            this.mergeRoles();
            this.mergeProjectGroups();
        });
    }

    public ngOnInit() {
        if (!this.store.getState().user.roles) {
            this.store.dispatch({ type: userActions.GET_ROLES });
        } else {
            this.mergeRoles();
        }
        if (!this.store.getState().user.projectGroup) {
            this.store.dispatch({ type: userActions.GET_PROJECT_GROUPS });
        } else {
            this.mergeProjectGroups();
        }
        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().user.roles) {
                this.mergeRoles();
            }
            if (this.store.getState().user.projectGroups) {
                this.mergeProjectGroups();
            }
        });
    }

    public ngOnDestroy() {
        this.unSubscribe();
    }

    private mergeRoles() {
        const hasDomainRoles = this.domain && this.domain.groupsMapping && this.domain.groupsMapping.roles;
        this.roles = this.mergeMapping(hasDomainRoles, _.cloneDeep(this.store.getState().user.roles));
    }

    private mergeProjectGroups() {
        const hasDomainProjectGroups = this.domain && this.domain.groupsMapping
            && this.domain.groupsMapping.projectGroups;
        this.projectGroups = this.mergeMapping(hasDomainProjectGroups, this.getProjectGroupsFiltered());
    }

    private mergeMapping(domainBoundMapping: any, storeData: any) {
        if (domainBoundMapping && storeData) {
            domainBoundMapping.forEach((x: any) => {
                storeData.find(({ id }) => x.id === id).group = x.group;
            });
        }
        return storeData;
    }

    private getProjectGroupsFiltered() {
        const userState = this.store.getState().user;
        if (userState && userState.projectGroups) {
            return _.cloneDeep(userState.projectGroups.filter(({ id }) => id !== 1));
        }
        return [];
    }

    public changeMapping(domainMapping: any, objMapping: any) {
        if (domainMapping.some((x: any) => x.id === objMapping.id) === false) {
            domainMapping.push({ id: objMapping.id, group: objMapping.group });
        } else {
            const objFound = domainMapping.find((x: any) => x.id === objMapping.id);
            if (objMapping.group.trim().length === 0) {
                const index = domainMapping.indexOf(objFound);
                if (index !== -1) {
                    domainMapping.splice(index, 1);
                }
            } else {
                objFound.group = objMapping.group;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/domain-manager/domain-item/domain-directory-service-sync/domain-directory-service-sync.component.ts